<template>
  <div>
    <div  v-if="this.$route.name === 'home'">
      <Home />
    </div>
    <div v-else>
      <Navbar />
      <p style="margin: 10px;">{{ this.$route.path }}</p>
      <div class="container mt-5">
        <router-view />
      </div>    
    </div>
  </div>
</template>

<script>
  import Home from './views/Home.vue'
  import Navbar from './components/Navbar.vue'

  export default {
    components: { Home, Navbar }
  };
</script>
<style type="text/css">
  /*.dm-body {
    background-color: #fff5ee; // chrome palette "seashell"
  }*/
</style>